import {
  createContext,
  useContext,
} from "react"
import type { EditableAccountMedication } from "src/types"

export interface AccountMedicationModalContextValue {
  openAccountMedicationModal: (
    accountMedication?: EditableAccountMedication,
  ) => void;
}

type ContextType = AccountMedicationModalContextValue | null
export const AccountMedicationModalContext = createContext<ContextType>(null)

export function useAccountMedicationModalContext() {
  const context = useContext(AccountMedicationModalContext)

  if (context === null) {
    throw new Error("AccountMedicationModal components must be wrapped in <AccountMedicationModalContext />")
  }

  return context
}
